import $ from "jquery";
import ImageUpload from "./components/ImageUpload";
import SubmissionForm from "./components/SubmissionForm";
import FriendlyCaptcha from "./components/FriendlyCaptcha";
import TextareaCounter from "./components/TextareaCounter";
ImageUpload.mount();
FriendlyCaptcha.mount();
TextareaCounter.mount($('.form-textarea-wrapper'), ".textarea-counter__value");
let panelCounter = TextareaCounter.mount($('.panel--idea-explanation'), ".panel__total_text_counter__value");
if (panelCounter.length > 0) {
    SubmissionForm.mount(panelCounter[0]);
}
